const options = {
  5: "bg-indigo-200/5",
  10: "bg-indigo-200/10",
  25: "bg-indigo-200/25",
  50: "bg-indigo-200/50",
  75: "bg-indigo-200/75",
  90: "bg-indigo-200/90",
  100: "bg-indigo-200",
};

const from = {
  5: "from-indigo-200/5",
  10: "from-indigo-200/10",
  25: "from-indigo-200/25",
  50: "from-indigo-200/50",
  75: "from-indigo-200/75",
  90: "from-indigo-200/90",
  100: "from-indigo-200",
};

export default function getBackgroundIndigo200(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
  